import script from "./media.vue?vue&type=script&setup=true&lang=ts"
export * from "./media.vue?vue&type=script&setup=true&lang=ts"

import "./media.vue?vue&type=style&index=0&id=70a75d95&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a75d95"]])

export default __exports__